import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n.ts';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

if (!root) {
    throw new Error('Root container missing in index.html');
}
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

reportWebVitals();
